<template>
    <!-- Header -->
    <div class="footer d-flex justify-content-center align-items-center text-white">
        <!-- Logo -->
        <p style="text-align:center; font-size: 14px; margin-bottom: 0;">
            &copy; 2025 Trung tâm Chuyển đổi số tỉnh Đồng Tháp
        </p>
        <!-- /Logo -->

    </div>
    <!-- /Header -->
</template>

<script>
export default {
    data() {
        return {
        };
    },


};
</script>
